// 表記の畳み込み。判定の意味に依存しない純粋な正規化なので、はい/いいえ判定
// (yesNoIntent) と割り込み判定 (interruptionJudge) で共有する。
// 厳密な自然言語理解は目指さない (spec 2026-07-19 D17 の方針を踏襲)。
//
// 鉤括弧を落とすのは、読み上げ文に「はい」のような引用が入るため
// (割り込み判定は読み上げ文と発話を突き合わせる)。読み上げ側の
// toSpeechText も鉤括弧を落としているので、扱いが揃う。
export function normalizeForMatch(s: string): string {
  return s
    .replace(/[。、．，！？!?\s「」『』・…]/g, "")
    .replace(/[！-～]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .toLowerCase();
}
